import { render, staticRenderFns } from "./DashboardEmployees.vue?vue&type=template&id=25c0bb24&scoped=true"
import script from "./DashboardEmployees.vue?vue&type=script&lang=js"
export * from "./DashboardEmployees.vue?vue&type=script&lang=js"
import style0 from "./DashboardEmployees.vue?vue&type=style&index=0&id=25c0bb24&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c0bb24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25c0bb24')) {
      api.createRecord('25c0bb24', component.options)
    } else {
      api.reload('25c0bb24', component.options)
    }
    module.hot.accept("./DashboardEmployees.vue?vue&type=template&id=25c0bb24&scoped=true", function () {
      api.rerender('25c0bb24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/gestion/dashboards/DashboardEmployees.vue"
export default component.exports